import { checkout } from '../objects/checkout'
// https://shopify.dev/docs/api/storefront/2023-10/objects/Checkout
export const retreiveCheckout = `
query checkoutFetch($id: ID!) {
  node(id: $id) {
    ... on Checkout ${checkout}
  }
}`
